import { useEffect } from "react";
import Lenis from "lenis";
import SiteHeader from "@/components/SiteHeader";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import IbcSection from "@/components/landing/IbcSection";
import GgkSection from "@/components/landing/GgkSection";
import Regulation from "@/components/landing/Regulation";
import WeightDivisions from "@/components/landing/WeightDivisions";
import License from "@/components/landing/License";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#0A0A0A] min-h-screen" data-testid="landing-page">
      <SiteHeader />
      <Hero />
      <Marquee />
      <Manifesto />
      <IbcSection />
      <GgkSection />
      <Regulation />
      <WeightDivisions />
      <License />
      <Faq />
      <Footer />
    </div>
  );
}
